// extracted by mini-css-extract-plugin
export var actionIcon = "_pe-0";